module.exports = __webpack_public_path__ + "static/2-2b9d5ca7ae469dd911e2df3e6f69ab4d.svg";